<div class="d-flex flex-column container">
  <div class="form" id="footer-newsletter-block"></div>
</div>
